/** 任意改变数组内数据的顺序 */
export function shuffle(array) {
    let currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
}
// shuffle(array) {
//   let len = array.length;
//   while (len) {
//     let randomIndex = Math.floor(Math.random() * len--);
//     [array[randomIndex], array[len]] = [array[len], array[randomIndex]];
//   }
//   return array;
// },

// shuffle(array) {
//   let currentIndex = array.length, randomIndex;
//
//   // シャッフルする要素が残っていますが
//   while (currentIndex > 0)
//   {
//     // 残りの要素を選択する
//     randomIndex = Math.floor(Math.random() * currentIndex);
//
//     currentIndex--;
//
//     // そして、それを現在の要素と交換します
//     [array[currentIndex], array[randomIndex]] =
//         [array[randomIndex], array[currentIndex]];
//   }
//   return array;
// },
